import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

/**
 * @param {{ query?: { search?: string, page?: number, limit?: number } }} option
 */
export const GetAll = async (option = {}) => {
  const response = await $api.get(Endpoints.OneTimeProductName.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const Get = async (option) => {
  const response = await $api.get(Endpoints.OneTimeProductName.Get(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{ id?: string | null, name: string }} form
 */
export const AddOrUpdate = async (form) => {
  const response = await $api.post(
    Endpoints.OneTimeProductName.AddOrUpdate({ params: {}, query: {} }),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const Delete = async (option) => {
  const response = await $api.delete(
    Endpoints.OneTimeProductName.Delete(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Get,
  AddOrUpdate,
  Delete,
};
